<template>
  <OpDialog
    :title="$t('breadcrumb.scenceMsg')"
    :visible.async="visible"
    class="uploadDailog"
    :modal-append-to-body="false"
    :ok-disabled="!planName || loading"
    :ok-loading="okLoading"
    @onOk="addPlan"
    @onClose="handleClose"
  >
    <div class="uploadDailog_content">
      <div class="img-container">
        <div v-if="loading" class="img-loading">
          <div class="img-loading_icon">
            <img src="https://appresource.opple.com/media/business/4850/20260126161333_1.png">
          </div>
          <div class="img-loading_title">
            <img src="https://appresource.opple.com/media/business/4850/20260126160832_7.png">
            <p>{{ loadingText }}</p>
          </div>
        </div>
        <div v-else>
          <img v-if="[1, 3].includes(type)" :src="imageUrl" class="planImage">
          <video
            v-if="type === 2"
            ref="videoPlayer"
            controls
            controlsList="nodownload noplaybackrate"
            disablePictureInPicture
            :src="videoUrl"
            class="planImage"
          />
        </div>
      </div>
      
      <div class="tips">
        <i class="el-icon-warning yellow" />
        <span>{{ infoText }}</span>
      </div>
      <div class="tips inputDiv">
        <span class="inputTitle">{{ $t('sceneCard.name') }}</span>
        <el-input
          v-model="planName"
          type="text"
          :placeholder="$t('sylogs.plhode3')"
          class="inputPlan"
          :maxlength="30"
        />
      </div>
      <!-- <OppleButton class="addBtn" :disabled="!planName || !imageUrl" @click="addPlan">
        {{ $t('projectList.add') }}
      </OppleButton> -->
    </div>
  </OpDialog>
</template>
<script>
import OpDialog from '@/components/common/OpDialog.vue'
import OppleButton from '@/components/Base/OppleButton/index.vue'
import { CreateMasterSceneBin, Create } from '@/axios/IScene.js'
import { alerterror, alertsuccess, warning } from "@/assets/js/common.js";
import { getdeviceImageStatus } from '@/utils/utils'

export default {
  components: {
    OpDialog,
    OppleButton
  },
  props: {
   visible: {
     type: Boolean,
     default: false
   },

   type: {
     type: Number,
     default: 1 // 1 图片方案 2 视频方案 3 ai
   },

   imageUrl: {
     type: String,
     default: ''
   },

   videoUrl: {
     type: String,
     default: ''
   },

   loading: {
     type: Boolean,
     default: false
   },

   device: {
      type: Object,
      default: () => ({})
    },

    showEntry: {
      type: Number,
      default: 7
    },

    videoThumbnail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      planName: '',
      startTime: '',
      okLoading: false,
    }
  },

  computed: {
    infoText() {
      switch (this.type) {
       case 1:
        case 3:
         return this.$t('tianmu.upImageTip');
        case 2:
         return this.$t('tianmu.upVideoTip');
        default:
         return '';
      }
    },
    loadingText() {
      switch (this.type) {
       case 1:
       case 2:
         return this.$t('tianmu.atUploading');
       case 3:
         return this.$t('tianmu.aiCreate')
        default:
         return '';
      }
    }
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗打开时清空输入框
        this.planName = '';
      }
    }
  },
  mounted() {
  },
  destroyed(){
  },
  methods: {
    async addPlan() {
      this.startTime = new Date().getTime();

      // 图片
      if ([1, 3].includes(this.type)) {
        if (!this.planName || !this.imageUrl) return;

        this.loopGetBin();
      }

      // 视频
      if (this.type === 2) {
        if (!this.planName || !this.videoUrl) return;

        this.loopGetBin();
      }
    },

    async loopGetBin(templateId) { 
      const newTime = new Date().getTime();

      // 超过2分钟算失败
      if (newTime - this.startTime > 120000) {
        warning(this, this.$t('sylogs.fail'));

        return;
      };

      try { 
        this.okLoading = true;

        let SnapshotUrl = '';
        let FileUrl = '';
        let ResourceType = '';

        if ([1, 3].includes(this.type)) {
          SnapshotUrl = this.imageUrl;
          FileUrl = this.imageUrl
          ResourceType = 'Image'
        }

        if (this.type === 2) {
          SnapshotUrl = this.videoThumbnail;
          FileUrl = this.videoUrl
          ResourceType = 'Video'
        }

        const params = {
          ClassSku: this.device.ClassSku || "",
          SnapshotUrl, // 封面
          FileUrl, // 文件url
          TemplateId: templateId || '', //模板id，不传
          ResourceType, // 图片 或 视频
          ResourceName: this.planName,
          ProductType: "PrimeLight" //固定值
        };

        const res = await CreateMasterSceneBin(params);

        if (res.StatusCode !== this.$store.state.rightStatusCode) {
          warning(this, this.$t('sylogs.fail'));
          this.okLoading = false;

          return;
        }

        const ResultCode = res?.Result.ResultCode;

        if ([1, 2].includes(ResultCode)) {
          setTimeout(() => {
            this.loopGetBin(res?.Result.TempId);
          }, 3000);
          
          return;
        };
        
        if (ResultCode == 3) {
          this.createScene(res);
          this.okLoading = false;
        };

        if (ResultCode === 4) {
          warning(this, this.$t('sylogs.fail'));
          this.okLoading = false;

          return;
        }
      } catch (e) {
        this.okLoading = false;
      }
    },

    handleClose() {
      this.$emit('close');
    },

    async createScene(res) {
      const BinList = res?.Result.BinList;

      const bin = BinList.find(item => item.ColorModel === 1) || {};

      if (!bin.BinUrl) {
        warning(this, this.$t('sylogs.fail'));

        return;
      }

      const IconUrl = [1, 3].includes(this.type) ? this.imageUrl : this.videoThumbnail;

      const params = {
        GpNo: this.device.Gpno, //房间号
        SecneName: this.planName || "", //场景名
        isFavorite: false, //固定
        IconUrl,
        WellSkyTemplateId: '', //sceneTemplate?.Id || "", //主题光专用场景模板id， ai生成的不给
        ShowEntry: this.showEntry,
        TransportType: "VideoScene",
        DeviceList: [
          {
            AreaName: this.device.AreaName || "",
            Mac: this.device.Mac,
            DeviceName: this.device.DeviceName,
            VDeviceId: this.device.VDeviceId,
            ChannelId: this.device.ChildId,
            ActionList: [
              {
                MsgType:  "0x131D0000", //固定值
                Values: [
                    {
                        KeyId: 0,
                        Value: 0
                    },
                    {
                        KeyId: 1,
                        Value: 0
                    },
                    {
                        KeyId: 2,
                        Value: parseInt("0xFFFFFFFF")
                    },
                    {
                        KeyId: 3,
                        Value: 255
                    },
                    {
                        KeyId: 4,
                        Value: parseInt("0xFFFFFFFF")
                    },
                    {
                        KeyId: 5,
                        Value: bin.BinUrl // fileUrl //转码后的bin文件地址
                    },
                ]
              }
            ]
          },
        ],
        AutoTemplateParams: { DataContent: { isCanEdit: false }  },
          // ...extraInfo,
      }

      const saveScene = await Create(params);

      if (saveScene.StatusCode === this.$store.state.rightStatusCode) {
        this.handleClose();
        this.$emit('refreshList');

        return;
      };      
    },

    lightStatus(data) {
      if (data?.StatusInfo) {
        if (getdeviceImageStatus(data, '0X0100', '0')) {
          return 'offline';
        } else if (getdeviceImageStatus(data, '0X02', '0') === true) {
          return 'off';
        } else {
          return 'on';
        }
      }
      return 'on';
    },
  }
}
</script>
<style lang="scss" scoped>
  .uploadDailog_content {
    padding: 80px;
    text-align: center;

    .planImage {
      width: 400px;
      height: 250px;
      object-fit: cover;
    }
    .tips {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      flex-direction: row;
      span {
        color: #3d3d3d;
        font-size: 15px;
      }
      .inputTitle {
        color: #333333;
        font-weight: 600;
        font-size: 13px;
        margin-right: 10px;
      }
      .yellow {
        color: rgba(255, 178, 0, 1);
        font-size: 15px;
        margin-right: 3px;
      }
      .inputPlan {
        width: 360px;
      }
    }
    .inputDiv {
      margin-top: 50px;
    }
    .addBtn {
      margin-top: 80px;
      padding: 0px 64px;
      background: #2145a4;
      border-radius: 6px;
      font-size: 19px;
      color: #fff;
      line-height: 40px;
      text-align: center;
    }
    .disable {
      opacity: 0.4;
      cursor: not-allowed;
    }

    .img-loading_icon {
      width: 60px;
      height: 60px;
      margin: 0 auto;
      transform-origin: 50% 50%;
      animation: rotate360 2s linear infinite;
      img {
        width: 100%;
        height: 100%;

      }
    }

    @keyframes rotate360 {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .img-loading {
      width: 500px;
      height: 170px;
      padding-top: 80px;
      margin: 0 auto;
      background: linear-gradient(270deg, #e2f1fe 2%, #c0b6fd 100%);

      &_title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        margin-top: 12px;
        font-size: 16px;

        p {
          margin-left: 10px;
        }
      }
    }
  }
</style>
